export function initSectionCollapse() {
	// Selettore per tutte le sezioni collapse
	let sectionCollapse = document.querySelectorAll('.Section__Collapse');
	if (!sectionCollapse.length) return;

	sectionCollapse.forEach((section) => {
		// Per ogni sezione collapse, gestisci solo le colonne al suo interno
		const columns = section.querySelectorAll('.kb-section-dir-vertical');
		if (!columns.length) return;

		columns.forEach((column) => {
			const button = column.querySelector('.wp-block-kadence-advancedbtn [role="button"]');
			if (!button) return;

			button.addEventListener('click', function (e) {
				e.preventDefault();
				if (column.classList.contains('active')) {
					column.classList.remove('active');
					return;
				}
				columns.forEach((col) => col.classList.remove('active'));
				column.classList.add('active');
			});
		});
	});
}